import { Box, CircularProgress, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './useStyles'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { updateAppVersionRTEnviroments } from '../../../app/services/versionEnviroments/updateAppVersionRTEnviroments'
import {
  featureFlagsAppCodes
} from '../../../utils/traducTypes'
import { logEvent } from '../../../utils/LogEvents'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../redux/actions/app'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  height: 225,
  bgcolor: 'white',
  p: 3,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export const DeprecateVersion = ({ version = null, plataform }) => {
  const classes = useStyles()
  const [showCircularProgress, setShowCircularProgress] = useState(false)
  const [openModal, setopenModal] = useState(false)

  const handleOpen = () => {
    setopenModal(true)
  }
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const deprecateVersion = async () => {
    setShowCircularProgress(true)
    if (!version) {
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar('Ocurrió un error. Intente nuevamente'))
      setTimeout(() => {
        navigate(0)
      }, 1000)
      return
    }
    try {
      const deprecatedVersion = await updateAppVersionRTEnviroments(
        featureFlagsAppCodes[0],
        plataform,
        version.appVersionCode
      )

      logEvent('CGI - updateAppVersionRTEnviroments', {
        body: {
          appCode: featureFlagsAppCodes[0],
          plataform,
          appVersionCode: version.appVersionCode,
          deprecatedVersion: new Date().toISOString()
        },
        response: deprecatedVersion
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Versión deprecada con éxito'))
      setTimeout(() => {
        navigate(0)
      }, 1000)
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar('Ocurrió un error al deprecar la versión'))
    }
    setShowCircularProgress(false)
  }

  return (
    <>
      <button className={classes.buttonDeprecateVersion} onClick={handleOpen}>
        <Typography
          className={classes.typographyButton}
          style={{
            color: '#263057'
          }}
        >
          Deprecar
        </Typography>
      </button>
      <Modal open={openModal} onClose={() => setopenModal(false)}>
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon
              sx={{
                fontSize: 'medium',
                color: '#263057',
                cursor: 'pointer'
              }}
              onClick={() => setopenModal(false)}
            />
          </div>
          <div>
            <Typography sx={{ color: '#263057', fontSize: '1.3em' }}>
              Deprecar versión
            </Typography>
          </div>
          <Typography
            sx={{
              color: '#263057',
              fontFamily: 'Roboto',
              marginTop: '5%'
            }}
          >
            ¿Esta seguro de que desea deprecar la version{' '}
            {version?.appVersionCode || ''}?
          </Typography>

          <Box className={classes.buttons} style={{ marginLeft: '45%' }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              deprecateVersion={deprecateVersion}
            />

            <ButtonClose handleClose={() => setopenModal(false)} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm ({ showCircularProgress, deprecateVersion }) {
  const classes = useStyles()

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className={`${classes.confirmButton}`}
        disabled={showCircularProgress}
        onClick={deprecateVersion}
      >
        {showCircularProgress
          ? (
          <CircularProgress size="1.5rem" color="inherit" />
            )
          : (
          <Typography className={classes.confirmButtonTypography}>
            Confirmar
          </Typography>
            )}
      </button>
    </div>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
